import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/landingpage.css";
import { Container, Box, Grid, Stack } from "@mui/material";
// import '../../assets/css/styles.css';
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/system";
import Image from "../image";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

// import Banner from '../../assets/images/banner.png';
import megaconnectNewLogo from "../../assets/images/Megaconnect_footer_logo.svg";
import Iconify from "../iconify";
import { useResponsive } from "../../hooks/use-responsive";
const footerstyle = {
  typography: {
    fontFamily: "Roboto Flex",
    fontSize: "18px",
    fontStyle: 'italic',
    letterSpacing: "0px",
    fontWeight: '400',
    lineHeight: '27px',

    "@media (max-width: 750px)": {
      fontSize: "14px",
      textAlign: "center",
      lineHeight: "21px",
    },
  },
  creditText: {
    fontFamily: "Roboto Flex",
    fontSize: "14px",
    lineHeight: "21px",
    letterSpacing: "0px",
    fontWeight: '400',
    textAlign: 'justify',


    "@media (max-width: 750px)": {
      fontFamily: "Roboto Flex",
      fontSize: "12px",
      textAlign: "center",
      lineHeight: "21px",
    },
  },
};
const AccordionItem = styled(Accordion)(({ theme }) => ({
  // backgroundColor: "#1D53E7",
  color: "#1D53E7",
  transition: "background-color 0.3s ease",
  boxShadow: "none",
  fontFamily: "Roboto Flex",
  fontStyle: 'italic',
  fontSize: "16px",
  fontWeight: 800,
  border: "none",
  backgroundColor: "white", // Set background color to white
  "&:before": {
    display: "none", // Removes the default Accordion border
  },

  "& a": {
    display: "flex",
    flexDirection: "column",
    textDecoration: "none",
    fontStyle:'normal',
    color: "black",
    fontFamily: "Roboto Flex",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
  },
}));

function FooterLandingpage() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const [expanded, setExpanded] = React.useState(false);
  const mdUp = useResponsive("up", "md");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Container maxWidth={false}>
      <div className="footer-container-main">
        <div className="footer-container">
          {/* <Box
            sx={{
              // position: 'relative',
              display: "grid",
              rowGap: 1,
              columnGap: 1,
              mt:{ sx:'20px', md:'84px'},
              // whiteSpace:'pretty',
              gridTemplateColumns: {
                // xs: "repeat(1, 1fr)",   // For small screens (1 column)
                sm: "repeat(2, 1fr)",   // For medium screens (2 columns)
                md: "repeat(2, 1fr)",   // For larger screens (3 columns)
              },
      
            }}
          > */}
          <Grid container sx={{ spacing: { sm: 0, md: 4 }, }}>
            <Grid item sm={4} md={4} lg={4} className="footer-img-anchor">
              <Grid item className="footer-img-land">
                < Image src={megaconnectNewLogo} alt="companyLogo" sx={{ maxWidth: { md: 330, sm: 150 }, minWidth: 150 }} />
                <Typography
                  gutterBottom
                  sx={{
                    ...footerstyle.typography,
                    marginTop: "20px",
                    textAlign: "left",
                    // color: "#FFFFFF",
                  }}
                >
                  Where Technology Meets Safety!
                </Typography>
              </Grid>

            </Grid>
            <Grid item sm={8} md={8} lg={8}>
              <Box
                sx={{
                  // position: 'relative',
                  display: "grid",
                  rowGap: 2,
                  columnGap: { sm: 3, md: 12 },
                  // mt:{ sx:'20px', md:'84px'},
                  whiteSpace: 'pretty',
                  gridTemplateColumns: {
                    // xs: "repeat(1, 1fr)",   // For small screens (1 column)
                    sm: "repeat(3, 3fr)",   // For medium screens (2 columns)
                    md: "repeat(3, 3fr)",   // For larger screens (3 columns)
                  },

                }}
              >

                {/* COMPANY Section */}
                <Grid item xs={12} md={12} className="link-column-footer">
                  <Stack direction="column" spacing={2} sx={{ whiteSpace: "nowrap" }}>
                    <h4
                      style={{
                        color: '#1D53E7',
                        fontFamily: 'Roboto Flex',
                        fontStyle: 'italic',
                        fontWeight: '800',
                      }}
                    >
                      Product
                    </h4>
                    <Link to="/" onClick={scrollToTop}>Home</Link>
                    {/* <Link to="/aboutcompany" onClick={scrollToTop}>About Us</Link> */}
                    <Link to="/Features" onClick={scrollToTop}>Features</Link>
                    <Link to="/plans" onClick={scrollToTop}>Pricing</Link>
                    <Link to="/refer_and_earn" onClick={scrollToTop}>Refer & Earn</Link>
                  </Stack>
                </Grid>

                {/* LEGAL Section */}
                <Grid item xs={12} md={12} className="link-column-footer">
                  <Stack direction="column" spacing={2} sx={{ whiteSpace: "nowrap" }}>
                    <h4
                      style={{
                        color: '#1D53E7',
                        fontFamily: 'Roboto Flex',
                        fontStyle: 'italic',
                        fontWeight: '800',
                      }}
                    >Contact</h4>
                    <Link to="/contactus" onClick={scrollToTop}>Contact Us</Link>
                    <Link to="/user_signup" onClick={scrollToTop}>Sign Up</Link>
                    <Link to="/user_Login" onClick={scrollToTop}>Login</Link>
                  </Stack>
                </Grid>

                {/* RESOURCES Section */}
                <Grid item xs={12} md={12} className="link-column-footer">
                  <Stack direction="column" spacing={2} sx={{ whiteSpace: "nowrap" }}>
                    <h4
                      style={{
                        color: '#1D53E7',
                        fontFamily: 'Roboto Flex',
                        fontStyle: 'italic',
                        fontWeight: '800',
                      }}
                    >Follow Us</h4>
                    <Link to="https://www.facebook.com/profile.php?id=61550346193394" target='_blank'
                      onClick={scrollToTop} style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Iconify icon="ri:facebook-fill" width="24px" height="24px" style={{ color: 'black' }} />
                        <span>Facebook</span>
                      </Stack>
                    </Link>
                    <Link to="https://www.instagram.com/megaconnect.cloud?utm_source=qr&igsh=MW41bzI4aGltbGpwMA==" target='_blank'
                      onClick={scrollToTop} style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Iconify icon="flowbite:instagram-solid" width="24px" height="24px" style={{ color: 'black' }} />
                        <span>Instagram</span>
                      </Stack>
                    </Link>
                    <Link to="https://youtube.com/@MegaconnectTechnologies?si=SF_9Uzh6Ys7cxxed" target='_blank'
                      onClick={scrollToTop} style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Iconify icon="ri:youtube-fill" width="24px" height="24px" style={{ color: 'black' }} />
                        <span>YouTube</span>
                      </Stack>
                    </Link>
                    <Link to="https://www.linkedin.com/company/95772245/admin/feed/posts/" target='_blank'
                      onClick={scrollToTop} style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Iconify icon="uil:linkedin" width="24px" height="24px" style={{ color: 'black' }} />
                        <span>LinkedIn</span>
                      </Stack>
                    </Link>



                  </Stack>


                </Grid>

              </Box>
            </Grid>
          </Grid>

        </div>
        <Box
          className="footer-container-smallscreen"
          sx={{
            display: "none",
            "@media (max-width: 791px)": {
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "flex-start",
              // backgroundColor: "#1E53E8",
              // borderRadius: "30px 30px 0px 0px",
              // padding: "24px 34px",
              // position: "relative",
              Zindex: "1",
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',  // Stack elements in a column
              justifyContent: 'left', // Align vertically to the top
              alignItems: 'flex-start',     // Align horizontally to the left
              height: '100%',               // Optional: makes sure it takes the full height of the parent
              position: "relative",
            }}
          >
            <Box>
              <img src={megaconnectNewLogo} alt="companyLogo" width={150} />
            </Box>
            <Typography
              gutterBottom
              sx={{
                ...footerstyle.typography,
                marginTop: "10px",
                textAlign: "left",
              }}
            >
              Where Technology Meets Safety!
            </Typography>
          </Box>

          <AccordionItem
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            sx={{ width: "100%", marginTop: "10px" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#1D53E7" }} />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              Product
            </AccordionSummary>
            <AccordionDetails  >
              <Stack direction='column' spacing={2} >
                <Link to="/" onClick={scrollToTop}>Home</Link>
                <Link to="/features" onClick={scrollToTop}>Features</Link>
                {/* <Link to="/product" onClick={scrollToTop}>
                Products
              </Link> */}
                <Link to="/plans" onClick={scrollToTop}>Pricing</Link>
                <Link to="/refer_and_earn" onClick={scrollToTop}>Refer & Earn</Link>
              </Stack>
            </AccordionDetails>
          </AccordionItem>
          <AccordionItem
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
            sx={{ width: "100%", marginTop: "10px" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#1D53E7" }} />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              Contact
            </AccordionSummary>
            <AccordionDetails>
              <Stack direction='column' spacing={2} >
                <Link to="/contactus" onClick={scrollToTop}>Contact Us</Link>
                <Link to="/user_signup" onClick={scrollToTop}>Sign Up</Link>
                <Link to="/user_Login" onClick={scrollToTop}>Login</Link>
              </Stack>
            </AccordionDetails>
            <AccordionActions></AccordionActions>
          </AccordionItem>
          <AccordionItem
            sx={{ width: "100%", marginTop: "10px" }}
          >
            <AccordionSummary aria-controls="panel2-content" id="panel2-header">
              <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4
                  style={{
                    color: '#1D53E7',
                    fontFamily: 'Roboto Flex',
                    fontStyle: 'italic',
                    fontWeight: '800',
                    margin: 0, // Remove default margin for better alignment
                  }}
                >
                  Follow Us
                </h4>

                <Stack direction="row" spacing={4} sx={{ alignItems: 'center',  }}>
                  <Link
                    to="https://www.facebook.com/profile.php?id=61550346193394"
                    target='_blank'
                    onClick={scrollToTop}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <Iconify icon="ri:facebook-fill" width="24px" height="24px" style={{ color: 'black' }} />
                  </Link>

                  <Link
                    to="https://www.instagram.com/megaconnect.cloud?utm_source=qr&igsh=MW41bzI4aGltbGpwMA=="
                    target='_blank'
                    onClick={scrollToTop}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <Iconify icon="flowbite:instagram-solid" width="24px" height="24px" style={{ color: 'black' }} />
                  </Link>

                  <Link
                    to="https://youtube.com/@MegaconnectTechnologies?si=SF_9Uzh6Ys7cxxed"
                    target='_blank'
                    onClick={scrollToTop}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <Iconify icon="ri:youtube-fill" width="24px" height="24px" style={{ color: 'black' }} />
                  </Link>

                  <Link
                    to="https://www.linkedin.com/company/95772245/admin/feed/posts/"
                    target='_blank'
                    onClick={scrollToTop}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <Iconify icon="uil:linkedin" width="24px" height="24px" style={{ color: 'black' }} />
                  </Link>
                </Stack>
              </Stack>
            </AccordionSummary>
          </AccordionItem>


          {/* <AccordionItem
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
          sx={{ width: "100%", marginTop: "10px" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            DOWNLOADS
          </AccordionSummary>
          <AccordionDetails>
            <Link onClick={scrollToTop}>iOs</Link>
            <Link onClick={scrollToTop}>Android</Link>
            <Link onClick={scrollToTop}>Mac</Link>
            <Link onClick={scrollToTop}>Chrome</Link>
          </AccordionDetails>
          <AccordionActions></AccordionActions>
        </AccordionItem> */}

        </Box>
        {mdUp && <Divider color='1px solid #808080' />}
        {!mdUp && <Divider
          // component="li"
          // light
          sx={{
            backgroundColor: "50px solid black", height: "5px", marginTop: "0px",
            "@media (max-width: 791px)": {
              marginTop: "30px"
            }
          }}
        />}

        {mdUp && <Stack direction={{ sm: 'row', md: 'row' }} justifyContent="space-between">
          <Typography
            sx={{
              marginTop: "20px",
              ...footerstyle.creditText,
              color: "#858585",
            }}
          >
            © 2024 Megaconnect Technologies Private
            Limited I All Rights Reserved

          </Typography>
          <Box sx={{ marginTop: "20px", }}>
            <Stack direction='row' spacing={2}>
              <Link
                to="/privacy"
                onClick={scrollToTop}
                underline="always"
                style={{
                  color: "#1D53E7",
                  ...footerstyle.creditText,

                }}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms&condition"
                onClick={scrollToTop}
                underline="always"
                style={{
                  color: "#1D53E7",
                  ...footerstyle.creditText,
                }}
              >
                Terms and Conditions
              </Link>
              {/* <Link
            to="/terms&condition"
            onClick={scrollToTop}
            underline="always"
            style={{
              color: "#1D53E7" ,
              ...footerstyle.creditText,
            }}
          >
            Cookies Settings
          </Link> */}
            </Stack>
          </Box>
        </Stack>}
        {!mdUp && <Stack direction={{ sm: 'row', md: 'row' }} justifyContent="space-between">

          <Box sx={{ marginTop: "20px", }}>
            <Stack direction='row' spacing={3} sx={{ alignItems: 'center', justifyContent: 'center' }}>
              <Link
                to="/privacy"
                onClick={scrollToTop}
                underline="always"
                style={{
                  color: "#1D53E7",
                  ...footerstyle.creditText,

                }}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms&condition"
                onClick={scrollToTop}
                underline="always"
                style={{
                  color: "#1D53E7",
                  ...footerstyle.creditText,
                }}
              >
                Terms and Conditions
              </Link>
              {/* <Link
            to="/terms&condition"
            onClick={scrollToTop}
            underline="always"
            style={{
              color: "#1D53E7" ,
              ...footerstyle.creditText,
            }}
          >
            Cookies Settings
          </Link> */}
            </Stack>
          </Box>
          <Typography
            sx={{
              marginTop: "20px",
              ...footerstyle.creditText,
              color: "#858585",
              alignItems: 'center'
            }}
          >
            © 2024 Megaconnect Technologies Private
            Limited I All Rights Reserved

          </Typography>
        </Stack>}
      </div>
    </Container>
  );
}

export default FooterLandingpage;
